import { FC } from 'react';
import { IonContent, IonPage } from '@ionic/react';
import ControllersGrid from '../../components/controllers/ControllersGrid';
import { useIntl } from 'react-intl';
import { ControllerMessages } from 'src/intl/ControllerMessages';
import DesktopHeader from 'src/components/reusable-components/desktop-header/DesktopHeader';
import { useHistory, useLocation } from 'react-router';
import React from 'react';
import { useToast } from 'src/components/reusable-components/useToast';
import { englishOnlyIntl, useGA4 } from '../../utils/ga4';

// Route based actions that can be performed on the page.
export enum ControllerListPageActions {
  'ReassignmentSuccessful',
  'ReassignmentUnsuccessful',
}

export interface ControllerListPageState {
  action?: ControllerListPageActions;
  controllerPhysicalSerial?: string;
  organizationName?: string;
}

const ControllersListPage: FC = () => {
  document.title = englishOnlyIntl.formatMessage(ControllerMessages.controllersHeader);
  useGA4();

  const { formatMessage } = useIntl();
  const [present] = useToast();
  const history = useHistory();
  const { state: locationState } = useLocation<ControllerListPageState>();

  // Show deleted successful toast if the action occurred.
  React.useEffect(() => {
    if (locationState?.action === ControllerListPageActions.ReassignmentSuccessful) {
      history.replace({ state: {} });
      present(
        {
          message: formatMessage(ControllerMessages.reassignmentSuccessful, {
            physicalSerial: locationState.controllerPhysicalSerial,
            organization: locationState.organizationName,
          }),
        },
        'success',
      );
      return;
    }
    if (locationState?.action === ControllerListPageActions.ReassignmentUnsuccessful) {
      history.replace({ state: {} });
      present(
        {
          message: formatMessage(ControllerMessages.reassignmentUnsuccessful, {
            physicalSerial: locationState.controllerPhysicalSerial,
          }),
        },
        'danger',
      );
    }
  }, [history, formatMessage, locationState, present]);

  return (
    <IonPage>
      <DesktopHeader title={formatMessage(ControllerMessages.controllersHeader)} />
      <IonContent>
        <ControllersGrid />
      </IonContent>
    </IonPage>
  );
};

export default ControllersListPage;
